import React, { useState } from 'react';
import { Clock, Sun, Sunset } from 'lucide-react';

/**
 * TimeSlotSelector — Créneau livraison / reprise
 * Matin (8H-12H) / Après-midi (13H-18H) / Soir (18H-21H)
 */
const SLOTS = [
  { id: 'matin', label: 'Matin', time: '8H00 – 12H00', icon: <Sun size={14} />, recommended: false },
  { id: 'apres_midi', label: 'Après-midi', time: '13H00 – 18H00', icon: <Sunset size={14} />, recommended: true },
  { id: 'soir', label: 'Soir', time: '18H00 – 21H00', icon: <Clock size={14} />, recommended: false, surcharge: '+15€' },
];

const RETURN_SLOTS = [
  { id: 'retour_10h', label: 'Avant 10H00', time: 'Lendemain matin', icon: <Clock size={14} />, recommended: true, free: true },
  { id: 'retour_matin', label: 'Matin', time: 'Lendemain 8H–12H', icon: <Sun size={14} />, free: true },
  { id: 'retour_apres_midi', label: 'Après-midi', time: 'Lendemain 13H–18H', icon: <Sunset size={14} />, surcharge: '+15€ (1/2j suppl)' },
];

export default function TimeSlotSelector({ type = 'livraison', onSelect, selected }) {
  const slots = type === 'livraison' ? SLOTS : RETURN_SLOTS;
  const label = type === 'livraison' ? 'Créneau de livraison' : 'Créneau de reprise';

  return (
    <div>
      <p className="text-sm font-semibold mb-3" style={{ color: 'var(--ink)' }}>{label}</p>
      <div className="grid grid-cols-3 gap-2">
        {slots.map(slot => (
          <button key={slot.id}
            onClick={() => onSelect && onSelect(slot.id)}
            className="p-3 rounded-xl text-center transition-all"
            style={{
              background: selected === slot.id ? 'var(--teal)' : '#FFFFFF',
              border: `1.5px solid ${selected === slot.id ? 'var(--teal)' : 'var(--border)'}`,
              boxShadow: selected === slot.id ? '0 4px 12px rgba(93,188,191,0.2)' : 'none',
            }}>
            <div className="flex justify-center mb-1" style={{ color: selected === slot.id ? '#0B1E20' : 'var(--teal)' }}>{slot.icon}</div>
            <p className="text-xs font-bold" style={{ color: selected === slot.id ? '#0B1E20' : 'var(--ink)' }}>{slot.label}</p>
            <p className="text-xs" style={{ color: selected === slot.id ? 'rgba(11,30,32,0.6)' : 'var(--text-muted)' }}>{slot.time}</p>
            {slot.recommended && (
              <p className="text-xs font-semibold mt-0.5" style={{ color: selected === slot.id ? '#0B1E20' : 'var(--teal)' }}>Recommandé</p>
            )}
            {slot.surcharge && (
              <p className="text-xs mt-0.5" style={{ color: '#C58B19' }}>{slot.surcharge}</p>
            )}
          </button>
        ))}
      </div>
      {type === 'reprise' && (
        <div className="flex items-center gap-1.5 mt-2 p-2 rounded-lg"
          style={{ background: 'rgba(197,139,25,0.06)', border: '1px solid rgba(197,139,25,0.15)' }}>
          <Clock size={11} style={{ color: '#C58B19' }} />
          <p className="text-xs font-medium" style={{ color: '#C58B19' }}>
            Au-delà de 10H00 : facturation d’une demi-journée supplémentaire
          </p>
        </div>
      )}
    </div>
  );
}
